module.exports = __webpack_public_path__ + "static/media/Digital globe.a8663bde.jpg";